{
  "header": {
    "nameShowStaticText": false,
    "nameVariable": {
      "id": "f3c4290b-2576-478c-9c62-d58a4b4e7287",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6015",
      "displayName": "ProductInstanceUri",
      "variablePath": "<GroupIdentifier>.Identification.ProductInstanceUri",
      "dataType": "String",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "b090729a-6142-428e-8885-b23e3a32929e",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "<GroupIdentifier>.Identification.Model",
      "dataType": "LocalizedText",
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Controller Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "66e57643-aeaa-4286-b569-dcca076baaaa",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6002",
                "displayName": "Manufacturer",
                "variablePath": "<GroupIdentifier>.Identification.Manufacturer",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "6ee79e62-83d3-49f8-abf4-abe781848016",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6003",
                "displayName": "SerialNumber",
                "variablePath": "<GroupIdentifier>.Identification.SerialNumber",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Instance URI",
              "showAsLink": false,
              "valueVariable": {
                "id": "f3c4290b-2576-478c-9c62-d58a4b4e7287",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6015",
                "displayName": "ProductInstanceUri",
                "variablePath": "<GroupIdentifier>.Identification.ProductInstanceUri",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer URI",
              "showAsLink": false,
              "valueVariable": {
                "id": "b82b79f2-0f82-41da-848d-d2bed0e19dd2",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6007",
                "displayName": "ManufacturerUri",
                "variablePath": "<GroupIdentifier>.Identification.ManufacturerUri",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "7cd7eed8-8b3f-4871-b655-b8efa8ea609b",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "<GroupIdentifier>.Identification.ProductCode",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "b090729a-6142-428e-8885-b23e3a32929e",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6008",
                "displayName": "Model",
                "variablePath": "<GroupIdentifier>.Identification.Model",
                "dataType": "LocalizedText",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Task Control Monitoring",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Program Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "5e999686-b4f8-4d73-ab27-3d25e4151457",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=18915",
                "displayName": "TaskProgramName",
                "variablePath": "ParameterSet.TaskProgramName",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "True"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "False"
                }
              ],
              "label": "Program Loaded",
              "valueVariable": {
                "id": "3d589504-b156-411f-b4b6-7811c4e883ab",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=18916",
                "displayName": "TaskProgramLoaded",
                "variablePath": "ParameterSet.TaskProgramLoaded",
                "dataType": "Boolean",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#0084ff",
                  "textColor": "#ffffff",
                  "value": "0",
                  "label": "CYCLE"
                },
                {
                  "backgroundColor": "#fbff00",
                  "textColor": "#ffffff",
                  "value": "1",
                  "label": "CONTINUOUS"
                },
                {
                  "backgroundColor": "#7ad181",
                  "textColor": "#ffffff",
                  "value": "2",
                  "label": "STEP"
                }
              ],
              "label": "Execution Mode",
              "valueVariable": {
                "id": "c1784091-efaf-4d03-9559-acfdc71f308c",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=17876",
                "displayName": "ExecutionMode",
                "variablePath": "ParameterSet.ExecutionMode",
                "dataType": "Enum",
                "modellingRule": "Optional",
                "hasProperties": false,
                "enumValues": {
                  "0": "CYCLE",
                  "1": "CONTINUOUS",
                  "2": "STEP"
                }
              }
            }
          ],
          "placeholderObject": "TaskControls.<TaskControlIdentifier>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "3a08441b-9b52-486d-bd89-e7546201fd83",
            "modelUri": "http://opcfoundation.org/UA/",
            "nodeId": "i=61",
            "displayName": "baseName",
            "variablePath": "baseName",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Software",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "f2864a06-b63b-4245-a797-0bb1496cd9be",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=18868",
                "displayName": "Manufacturer",
                "variablePath": "Manufacturer",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "1757906d-21f7-4309-924f-66063bd7ff6d",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=18870",
                "displayName": "Model",
                "variablePath": "Model",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Revision",
              "showAsLink": false,
              "valueVariable": {
                "id": "abc07c6b-8f35-4a7d-837c-dc92f8353742",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=18873",
                "displayName": "SoftwareRevision",
                "variablePath": "SoftwareRevision",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "Software.<SoftwareIdentifier>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "3a08441b-9b52-486d-bd89-e7546201fd83",
            "modelUri": "http://opcfoundation.org/UA/",
            "nodeId": "i=61",
            "displayName": "baseName",
            "variablePath": "baseName",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Current User",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Level",
              "showAsLink": false,
              "valueVariable": {
                "id": "3ea2ff17-2f0d-4e4a-b5a0-8653389874cd",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=17250",
                "displayName": "Level",
                "variablePath": "CurrentUser.Level",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "3660e891-95f5-48e0-8cce-706d9c70b121",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=18177",
                "displayName": "Name",
                "variablePath": "CurrentUser.Name",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": true,
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "97f38ad0-e03c-458e-b42e-25d20baa5dde",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15045",
                "displayName": "Manufacturer",
                "variablePath": "<GroupIdentifier>.Identification.Manufacturer",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "82c08880-a1e2-45a7-b88e-d758fc7892f3",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15048",
                "displayName": "SerialNumber",
                "variablePath": "<GroupIdentifier>.Identification.SerialNumber",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "bf2663b8-1807-4093-b714-1c0105314418",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15053",
                "displayName": "ProductCode",
                "variablePath": "<GroupIdentifier>.Identification.ProductCode",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Instance URI",
              "showAsLink": false,
              "valueVariable": {
                "id": "7f1feee8-5864-476b-82dc-2d2473b061bc",
                "modelUri": "http://opcfoundation.org/UA/DI/",
                "nodeId": "ns=1;i=15096",
                "displayName": "ProductInstanceUri",
                "variablePath": "<GroupIdentifier>.Identification.ProductInstanceUri",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "be723384-d954-42c9-800c-d2b2d7dccf7f",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15047",
                "displayName": "Model",
                "variablePath": "<GroupIdentifier>.Identification.Model",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Category",
              "showAsLink": false,
              "valueVariable": {
                "id": "6709b4fa-6831-4e5c-b1b0-0d15cf0af5e5",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15058",
                "displayName": "MotionDeviceCategory",
                "variablePath": "MotionDeviceCategory",
                "dataType": "Enum",
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OTHER",
                  "1": "ARTICULATED_ROBOT",
                  "2": "SCARA_ROBOT",
                  "3": "CARTESIAN_ROBOT",
                  "4": "SPHERICAL_ROBOT",
                  "5": "PARALLEL_ROBOT",
                  "6": "CYLINDRICAL_ROBOT"
                }
              }
            }
          ],
          "title": "Motion Device Identification"
        },
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Speed Override",
              "valueVariable": {
                "id": "e65b6af0-e55c-4869-ba88-8ffaa991c6fe",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15061",
                "displayName": "SpeedOverride",
                "variablePath": "ParameterSet.SpeedOverride",
                "dataType": "Double",
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              },
              "customRangeHigh": 30,
              "customRangeLow": 5
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "True"
                },
                {
                  "backgroundColor": "#f00000",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "False"
                }
              ],
              "label": "In Control",
              "valueVariable": {
                "id": "e1b98dd3-7c6e-4055-8094-a16beea18f02",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=16364",
                "displayName": "InControl",
                "variablePath": "ParameterSet.InControl",
                "dataType": "Boolean",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "True"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "False"
                }
              ],
              "label": "On Path",
              "valueVariable": {
                "id": "955b72f3-2d16-448d-a4e8-c3163d7a3278",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=16363",
                "displayName": "OnPath",
                "variablePath": "ParameterSet.OnPath",
                "dataType": "Boolean",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ],
          "title": "Motion Device Monitoring"
        },
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Axis Speed",
              "showAsLink": false,
              "valueVariable": {
                "id": "e1b98dd3-7c6e-4055-8094-a16beea18f02",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=16668",
                "displayName": "ActualSpeed",
                "variablePath": "ParameterSet.ActualSpeed",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Axis Position",
              "showAsLink": false,
              "valueVariable": {
                "id": "955b72f3-2d16-448d-a4e8-c3163d7a3278",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15863",
                "displayName": "ActualPosition",
                "variablePath": "ParameterSet.ActualPosition",
                "dataType": "Double",
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Motion Profile",
              "showAsLink": false,
              "valueVariable": {
                "id": "e65b6af0-e55c-4869-ba88-8ffaa991c6fe",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15808",
                "displayName": "MotionProfile",
                "variablePath": "MotionProfile",
                "dataType": "Enum",
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OTHER",
                  "1": "ROTARY",
                  "2": "ROTARY_ENDLESS",
                  "3": "LINEAR",
                  "4": "LINEAR_ENDLESS"
                }
              }
            }
          ],
          "placeholderObject": "Axes.<AxisIdentifier>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "84cedc96-13de-4c42-a1c6-775d9ce789b6",
            "modelUri": "http://opcfoundation.org/UA/",
            "nodeId": "i=61",
            "displayName": "baseName",
            "variablePath": "baseName",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ],
      "placeholderObject": "<MotionDeviceIdentifier>.[PLACEHOLDER]",
      "titleVariable": {
        "id": "84cedc96-13de-4c42-a1c6-775d9ce789b6",
        "modelUri": "http://opcfoundation.org/UA/",
        "nodeId": "i=61",
        "displayName": "baseName",
        "variablePath": "baseName",
        "dataType": "String",
        "modellingRule": "Mandatory",
        "hasProperties": false
      }
    },
    {
      "isPlaceholder": false,
      "title": "Safety States",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Operational Mode",
              "showAsLink": false,
              "valueVariable": {
                "id": "ae2e0404-cccb-41dd-972e-d46b33263811",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15740",
                "displayName": "OperationalMode",
                "variablePath": "ParameterSet.OperationalMode",
                "dataType": "Enum",
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "OTHER",
                  "1": "MANUAL_REDUCED_SPEED",
                  "2": "MANUAL_HIGH_SPEED",
                  "3": "AUTOMATIC",
                  "4": "AUTOMATIC_EXTERNAL"
                }
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#ff0505",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "STOP"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": " "
                }
              ],
              "label": "Emergency Stop",
              "valueVariable": {
                "id": "32f723f5-e0e2-43d9-b659-39328725173e",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15741",
                "displayName": "EmergencyStop",
                "variablePath": "ParameterSet.EmergencyStop",
                "dataType": "Boolean",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "STOP"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": " "
                }
              ],
              "label": "Protective Stop",
              "valueVariable": {
                "id": "e7c55046-c117-4cc8-862d-33a66aed47b1",
                "modelUri": "http://opcfoundation.org/UA/Robotics/",
                "nodeId": "ns=1;i=15742",
                "displayName": "ProtectiveStop",
                "variablePath": "ParameterSet.ProtectiveStop",
                "dataType": "Boolean",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "<SafetyStatesIdentifier>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "3a08441b-9b52-486d-bd89-e7546201fd83",
            "modelUri": "http://opcfoundation.org/UA/",
            "nodeId": "i=61",
            "displayName": "baseName",
            "variablePath": "baseName",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    }
  ]
}
